import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { ImportAndExportDataFilter } from '../../model/importAndExportDataFilter';
import { FileImportExportService } from '../../service/file-import-export.service';
import { LoggingService } from '../../../../services/logging.service';
import { CurrentVersion } from '../../model/CurrentVersion';

const apiServer = environment.apiServer;
const apiControl = '/mnn';

@Component({
  selector: 'app-project-mnn',
  templateUrl: './project-mnn.component.html'
})
export class MnnStarComponent implements OnInit {
  dataSetExportImportTable: any;
  importAndExportDataFilter: ImportAndExportDataFilter = new ImportAndExportDataFilter();
  dtOptionsExportImportTable: DataTables.Settings = {};
  selectedValueList: Array<CurrentVersion> = [];
  selectedValue: CurrentVersion = new CurrentVersion();
  tableReady: boolean = false;

  constructor(private http: HttpClient, private fileImportExportService: FileImportExportService, private spinner: NgxSpinnerService, private loggingService: LoggingService) {
    this.dataSetExportImportTable = [];

    fileImportExportService.http = http;
    fileImportExportService.spinner = spinner;
    fileImportExportService.apiControl = apiControl;
    fileImportExportService.downloadFileName = "Project_MNN.xlsx";
  }

  onImport(event) {
    const _xid = this.loggingService.generateUUID();
    this.loggingService.logStart(_xid, 'App.Components.MnnStarComponent.onImport', null, 'Импорт файла');

    this.fileImportExportService.onImport(event).then(() => {
      this.getVersions();
      this.onFieldChange(event);
      this.loggingService.logFinish(_xid, 'App.Components.MnnStarComponent.onImport', null, 'Импорт файла');
    }).catch(error => {
      this.loggingService.logError(_xid, 'App.Components.MnnStarComponent.onImport', error, null, 'Импорт файла');
    });
  }

  downLoadFile(data: any, type: string) {
    const _xid = this.loggingService.generateUUID();
    try {
      this.loggingService.logStart(_xid, 'App.Components.MnnStarComponent.downLoadFile', null, 'Скачивание файла');
      this.fileImportExportService.downLoadFile(data, type);
      this.loggingService.logFinish(_xid, 'App.Components.MnnStarComponent.downLoadFile', null, 'Скачивание файла');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.MnnStarComponent.downLoadFile', _error, null, 'Скачивание файла');
      throw _error;
    }
  }

  fileExport(event) {
    const _xid = this.loggingService.generateUUID();
    try {
      this.loggingService.logStart(_xid, 'App.Components.MnnStarComponent.fileExport', null, 'Экспорт данных');
      this.fileImportExportService.fileExport();
      this.loggingService.logFinish(_xid, 'App.Components.MnnStarComponent.fileExport', null, 'Экспорт данных');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.MnnStarComponent.fileExport', _error, null, 'Экспорт данных');
      throw _error;
    }
  }

  fileExportExample(event) {
    const _xid = this.loggingService.generateUUID();
    try {
      this.loggingService.logStart(_xid, 'App.Components.MnnStarComponent.fileExportExample', null, 'Экспорт примера');
      this.fileImportExportService.fileExportExample(event);
      this.loggingService.logFinish(_xid, 'App.Components.MnnStarComponent.fileExportExample', null, 'Экспорт примера');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.MnnStarComponent.fileExportExample', _error, null, 'Экспорт примера');
      throw _error;
    }
  }

  onFieldChange(event): void {
    const _xid = this.loggingService.generateUUID();
    try {
      this.loggingService.logStart(_xid, 'App.Components.MnnStarComponent.onFieldChange', null, 'Изменение фильтра');
      this.selectedValue = event;
      var table = $('#exportImportTable').DataTable();
      table.draw();
      this.loggingService.logFinish(_xid, 'App.Components.MnnStarComponent.onFieldChange', null, 'Изменение фильтра');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.MnnStarComponent.onFieldChange', _error, null, 'Изменение фильтра');
      throw _error;
    }
  }

  private getVersions() {
    const _xid = this.loggingService.generateUUID();
    this.loggingService.logStart(_xid, 'App.Components.MnnStarComponent.getVersions', null, 'Загрузка версий');

    this.http.get<any[]>(apiServer + "/GetVersions")
      .subscribe(resp => {
        for (let index = 0; index < resp.length; index++) {
          this.selectedValueList[index] = {
            id: resp[index].id,
            authorName: resp[index].authorName || "",
            createdAt: resp[index].createdAt || "",
          };
        }
        this.selectedValueList.unshift({
          id: null,
          authorName: null,
          createdAt: null,
        })

        this.selectedValue = this.selectedValueList[0];

        this.initDataTable();
        this.tableReady = true;
        this.loggingService.logFinish(_xid, 'App.Components.MnnStarComponent.getVersions', null, 'Загрузка версий');
      }, error => {
        this.loggingService.logError(_xid, 'App.Components.MnnStarComponent.getVersions', error, null, 'Загрузка версий');
      });
  }

  ngOnInit() {
    const _xid = this.loggingService.generateUUID();
    this.loggingService.logStart(_xid, 'App.Components.MnnStarComponent.ngOnInit', null, 'Инициализация компонента');

    this.spinner.show();

    this.fileImportExportService.updateVisibilytyFieldFromeRole();

    this.getVersions();

    this.loggingService.logFinish(_xid, 'App.Components.MnnStarComponent.ngOnInit', null, 'Инициализация компонента');
  }

  private initDataTable() {
    let numberFormat = Intl.NumberFormat("ru-RU", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    this.dtOptionsExportImportTable = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      lengthChange: false,
      searching: false,
      autoWidth: true,
      paging: true,
      info: false,
      orderCellsTop: true,
      scrollY: 'calc(100vh - 215px)',

      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {
        const _xid = this.loggingService.generateUUID();
        this.loggingService.logStart(_xid, 'App.Components.MnnStarComponent.getData', null, 'Загрузка данных');

        dataTablesParameters.search = this.importAndExportDataFilter.search;
        if (this.selectedValue != undefined && this.selectedValue.id != null)
          dataTablesParameters.version = this.selectedValue.id;

        let params = new HttpParams()
          .set('draw', dataTablesParameters.draw)
          .set('start', dataTablesParameters.start + 1)
          .set('length', dataTablesParameters.length)
          .set('search', dataTablesParameters.search || '')
          .set('version', dataTablesParameters.version || '')
          .set('order[0].column', dataTablesParameters.order[0].column)
          .set('order[0].dir', dataTablesParameters.order[0].dir);

        this.http.get<any>(apiServer + "/GetData", { params })
          .subscribe(resp => {
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: resp.data
            });
            this.spinner.hide();
            this.loggingService.logFinish(_xid, 'App.Components.MnnStarComponent.getData', null, 'Загрузка данных');
          }, error => {
            this.loggingService.logError(_xid, 'App.Components.MnnStarComponent.getData', error, null, 'Загрузка данных');
            this.spinner.hide();
          });
      },
      columns: [
        { "data": "rowNumber", "width": "10px" },
        { "data": "goodName" },
        { "data": "mnn" },
        { "data": "solocode" },
        { "data": "distributorNMCExtraCharge", "render": (data) => numberFormat.format(data) },
        { "data": "bottomPrice", "render": (data) => numberFormat.format(data) },
        { "data": "managerName" },
        { "data": "distributorName" }
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/project-mnn/project-mnn.component.ts